@if (loading) {
  <app-loading />
} @else {
  <span>
    <h2 class="heading-underline header-row">
      Enrichment field mappings
      <div class="search-bar">
        <input
          #searchInput
          class="search-bar__input"
          type="text"
          placeholder="Search fields mappings (Ctrl+Shift+F)..."
          [value]="searchTerm"
          (input)="onSearchInput($event)"
          (keydown.escape)="clearSearch()" />
        <i class="material-icons notranslate search-bar__icon header-action-icon"
           [class.has-value]="searchTerm"
           (click)="clearSearch()"
           (keydown.enter)="clearSearch()"
           (keydown.space)="$event.preventDefault(); clearSearch()"
           [attr.role]="searchTerm ? 'button' : null"
           [attr.aria-label]="searchTerm ? 'Clear search' : null"
           [attr.tabindex]="searchTerm ? '0' : '-1'"
           [matTooltip]="searchTerm ? 'Clear search' : ''"
           [matTooltipShowDelay]="500"
           matTooltipPosition="above">{{ searchTerm ? 'close' : 'search' }}</i>
      </div>
    </h2>
    <p class="section-description">Match Enrichment data fields to Bullhorn {{ candidateEntityLabel }} fields</p>
  </span>
  <div class="table-scroll-container scrollable-container">
    <table class="table table-striped table-no-border-bottom no-mar-b">
      <thead>
      <tr>
        <th class="col-enabled">
          <input type="checkbox" #allFieldsCheckbox class="kyloe-checkbox" [checked]="allFieldsEnabled" (change)="toggleAllFields()"
                 matTooltip="Enable or disable all field mappings" matTooltipPosition="right" [matTooltipShowDelay]="500" />
        </th>
        <th>Enrichment field</th>
        <th>Bullhorn field</th>
        <th>Overwrite strategy</th>
      </tr>
      </thead>
      <tbody>
        @for (group of fieldGroups; track group.key) {
          <tr class="group-header" [class.row-hidden]="groupHeaderHidden[group.key]" (click)="toggleGroup(group.key)">
            <td colspan="4">
              <div class="group-header-content">
                <i class="material-symbols-outlined group-chevron" [class.is-collapsed]="isGroupCollapsed(group.key)">expand_more</i>
                {{ group.label }}
                <span class="group-field-count">{{ group.fields.length }}</span>
              </div>
            </td>
          </tr>
          @for (field of group.fields; track field.key) {
            <tr [class.row-hidden]="rowHidden[field.key]" [class.row-disabled]="!fieldEnabled[field.key]">
              <td class="col-enabled">
                @if (isRequiredField(field.key)) {
                  <i class="material-symbols-outlined required-lock"
                     matTooltip="Required — must be mapped" matTooltipPosition="right" [matTooltipShowDelay]="500">lock</i>
                } @else {
                  <input type="checkbox" class="kyloe-checkbox" [checked]="fieldEnabled[field.key]" (change)="toggleField(field.key)"
                         [matTooltip]="(fieldEnabled[field.key] ? 'Disable' : 'Enable') + ' this field mapping'" matTooltipPosition="right" [matTooltipShowDelay]="500" />
                }
              </td>
              <td class="field-label indented">
                <div class="field-label-content">
                  @if (field.brandIcon) {
                    <span class="brand-icon brand-icon--{{ field.brandIcon }}"></span>
                  } @else {
                    <i class="material-symbols-outlined field-icon">{{ field.icon }}</i>
                  }
                  <span>
                  {{ field.label }}
                  @if(field.key == 'pdl.data') {
                    <i class="material-symbols-outlined full-response-tooltip"
                       matTooltip="When a record is fully enriched, write the complete enrichment response JSON to a Bullhorn field" matTooltipPosition="right" [matTooltipShowDelay]="500">question_mark</i>
                  }
                    </span>
                </div>
              </td>
              <td class="field-autocomplete">
                <app-paired-autocomplete
                  [selectedFieldControl]="fieldControls.get(field.key)"
                  [secondaryEntityControl]="entityControls.get(field.key)"
                  [primaryEntity]="primaryEntity"
                  [componentId]="'enrichment-' + field.key"
                  [entitiesOptions]="entitiesOptions"
                  [inputRequired]="isRequiredField(field.key)"
                  [dataSourceType]="dataSourceType"
                  [overlayPositioningConfig]="overlayPositioningConfig">
                </app-paired-autocomplete>
              </td>
              <td class="field-select">
                <mat-select [ngModel]="strategies[field.key]"
                            (ngModelChange)="onStrategyChange(field.key, $event)"
                            placeholder="Select...">
                  @for (option of strategyOptions; track option.value) {
                    <mat-option [value]="option.value">{{ option.label }}</mat-option>
                  }
                </mat-select>
              </td>
            </tr>
          }
        }
        @if (hasNoResults) {
          <tr>
            <td colspan="4" class="no-results">No fields match "{{ searchTerm }}"</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
